<template>
  <div class="thank-box">
    <!-- 头部 -->
    <div class="thank-header" @click="toggleExpand">
      <div class="header-left">
        <img
          :src="cdnUrl + 'ai-thank-icon.svg'"
          alt="思考完成"
          class="think-icon"
        />
        <span class="think-text" v-if="loading == 1">{{
          isAi ? "分析报告生成中..." : "正在思考..."
        }}</span>
        <span class="think-text" v-else-if="loading == 2 || (item && item.status && item.status == 'interrupted')">已停止</span>
        <span class="think-text" v-else>思考已完成</span>
      </div>
      <img
        :src="cdnUrl + (expanded ? 'ai-dowm-icon.svg' : 'ai-right-icon.svg')"
        alt="展开/收起"
        class="expand-icon"
      />
    </div>

    <!-- 展开内容 -->
    <div v-show="expanded" class="thank-content">
      <slot></slot>
      <div class="step-list" v-if="isAi && thoughtArr.length">
        <div v-for="(item, index) in thoughtArr" :key="index" class="step-item">
          <template v-if="item.type == 'task'">
            <img
              v-if="item.status === 'completed'"
              :src="cdnUrl + 'ai-thank-success.svg'"
              class="step-icon"
            />
            <img
              v-else-if="item.status === 2"
              :src="cdnUrl + 'ai-thank-empty.svg'"
              class="step-icon"
            />
            <img
              v-else-if="item.status === 'failed'"
              :src="cdnUrl + 'ai-thank-error.svg'"
              class="step-icon"
            />
            <div v-else-if="item.status === 'running'" class="step-loading">
              <img :src="cdnUrl + 'ai-card-loading.gif'" class="step-icon-bg" />
            </div>
            <span class="step-text">{{ item.msg }}</span>
          </template>
          <template v-else-if="item.type == 'txt'">
            <p>{{ item.msg }}</p>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ThankBox",
  props: {
    time: {
      type: [Number, String],
      default: "xx",
    },
    description: {
      type: String,
      default: "",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isAi: {
      type: Boolean,
      default: false,
    },
    thoughtArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      expanded: false,
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
    };
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
  },
};
</script>

<style lang="scss">
.thank-content {
  p {
    font-size: 14px;
    color: #999999;
  }
  li {
    color: #999 !important;
  }

  strong {
    font-weight: 400 !important;
  }
}
</style>

<style lang="scss" scoped>
.thank-box {
  width: 100%;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  overflow: hidden;
  background-color: #ffffff;
  margin-bottom: 8px;
}

/* 头部 */
.thank-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  transition: background-color 0.2s;

  .header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .think-icon {
    width: 20px;
    height: 20px;
  }

  .think-text {
    font-size: 14px;
    color: #999999;
  }

  .expand-icon {
    width: 16px;
    height: 16px;
    transition: transform 0.2s;
  }
}

/* 展开内容 */
.thank-content {
  padding: 0 16px 16px;

  p {
    font-size: 14px;
    color: #999999;
  }

  .content-text {
    padding: 12px 0;
    font-size: 14px;
    color: #606266;
    line-height: 1.6;
  }

  .content-list {
    margin: 0;
    padding-left: 20px;

    li {
      font-size: 14px;
      color: #606266;
      line-height: 2;
      list-style-type: disc;
    }
  }

  .step-list {

    .step-item {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0px;
      }

      .step-icon {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
      }

      .step-loading {
        position: relative;
        width: 16px;
        height: 16px;
        flex-shrink: 0;

        .step-icon-bg {
          width: 16px;
          height: 16px;
        }
      }

      .step-text {
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
</style>